import React, { useRef } from 'react';
import logo from "../../img/logo.png";
import logo2 from "../../img/logo2.png";
import "./AssignmentDesign.css";
import ReactToPdf from "react-to-pdf";
import ReactToPrint from 'react-to-print';
export default function AssignmentCoverPageDesign({
  assignmentType,
  title,
  courseCode,
  studentName,
  roll,
  term,
  year,
  stduentDept,
  sirName,
  sirRole,
  sirDept,
  date,
  faculty
}) {
  
  const ref = React.createRef();
  const componentRef = useRef();
  return (
    <div className="border border-2 p-2">
      {/* <ReactToPdf   targetRef={ref} filename="report.pdf"  scale={1} x={.5} y={.5}>
                {({ toPdf }) => 
                <button className='my-5 text-blue-700' onClick={toPdf}><i className="fas mx-1  fa-download"></i>Download</button>}
          </ReactToPdf> */}
        <ReactToPrint
        trigger={() => <button className='my-5 text-blue-700 mx-3'><i className="fas mx-1 fa-print"></i>Print</button>}
        content={() => componentRef.current}
      />

          <div ref={componentRef}>
          <div
      className="flex flex-col text-center justify-between"
      style={{
        background: `url(${logo2}) no-repeat center center`,
      }}
    >
      <div className="flex-col justify-center w-full flex mx-auto items-center ">
      <div className="w-full text-center mt-10 ">
          <h2 className="text-3xl text-blue-900 text-center">
            Noakhali Science & Technology University
          </h2>
          <p className="text-xl">Noakhali-3814,Bangladesh</p>
        </div>
        <img src={logo} alt="NSTU" className="w-24 my-5" /> 
      </div>
      <div className="text-2xl text-center">
        <h1 className="text-3xl font-bold my-5">{assignmentType} {assignmentType==='Lab'?'Report':''}</h1>
        <h2 className="mb-2">
          <span className="text-blue-900">Course Title :</span>
          {title}
        </h2>
        <h2>
          <span className="text-blue-900">Course Code :</span> {courseCode}
        </h2>
      </div>

      <div className="mt-3 text-center p-1">
        <div className="my-5">
          <h2 className="text-blue-900 text-xl uppercase">Prepared to</h2>
          <h3 className="text-2xl">{sirName}</h3>
          <h4 className="text-xl">{sirRole}</h4>
          <h4>Department of {sirDept}</h4>
          <h4>Noakhali Science & Technology University</h4>
        </div>
        <div className="my-5">
          <h2 className="text-blue-900 uppercase text-xl">Prepared by</h2>
          <h3 className="text-2xl">{studentName}</h3>
          <h4 className="text-xl">Roll : {roll}</h4>
          <h4>
            Year: {year} Term: {term}
          </h4>
          <h4>{stduentDept}</h4>
        </div>
      </div>
      
       <div className="text-center mt-10 mb-1">
       <h2 className="text-2xl my-2 text-blue-900 text-center">Submision Date : {date}</h2>
        <h1>Dept of {stduentDept}</h1>
        <h1 className="text-2xl my-2">Faculty of {faculty}</h1>
        <h4>Noakhali Science & Technology University</h4>
      </div>
          </div>
          </div>
    </div>
    
  );
}
